/**
 * Converts a string to kebab case.
 * @param {string} str - The input string.
 * @returns {string} - The kebab-cased string.
 */
export const kebabify = (str: string): string => {
  return str
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/([a-z])([A-Z])/g, '$1-$2') // Add hyphen between camelCase words
    .replace(/_/g, '-') // Replace underscores with hyphens
    .toLowerCase() // Convert to lowercase
}

export const getStringValue = (value: string | null) => {
  return value ? value.toString().toLowerCase() : ''
}
